<template>
  <div class="dingdan">
    <Breadtabsheader/>
    <!--查询-->
    <div class="h-piece h-mrt30 margin">
      <div class="h-formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="单据类型" prop="orderType">
              <el-select v-model="formInline.orderType" clearable placeholder="请选择" style="width:100%">
                <el-option v-for="item in orderTypeList"
                           :key="item.code"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="订单编号" prop="sapCode">
              <el-input v-model="formInline.sapCode" placeholder="请输入"
                        style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="售达方编码/名称" prop="sdfCodeNameLike">
              <el-input v-model="formInline.sdfCodeNameLike" placeholder="请输入"
                        style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="客户渠道" prop="customerChannelCode">
              <el-select v-model="formInline.customerChannelCode" clearable placeholder="请选择" style="width:100%">
                <el-option v-for="item in customerChannelList"
                           :key="item.code"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-collapse-transition>
            <div v-show="isScreen">
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="物料编码/名称" prop="materialCode">
                  <el-input v-model="formInline.materialCodeNameLike" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="国科物流单号" prop="waybillId">
                  <el-input v-model="formInline.waybillId" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="订单下单日期" prop="orderTime" style="width: 50%;">
                  <el-date-picker
                      v-model="clearTime"
                      type="daterange"
                      range-separator="至"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      @change="changeTime"
                      value-format="yyyy-MM-dd"
                  >
                  </el-date-picker>
                </el-form-item>




<!--                <el-form-item label="订单下单日期" prop="orderTime" style="width: 50%;">-->
<!--                  <el-date-picker-->
<!--                      v-model="formInline.orderTimeStart"-->
<!--                      clearable-->
<!--                      type="date"-->
<!--                      value-format="yyyy-MM-dd"-->
<!--                      placeholder="开始日期"-->
<!--                  >-->
<!--                  </el-date-picker>-->
<!--                  <span class="w-time-to">至</span>-->
<!--                  <el-date-picker-->
<!--                      v-model="formInline.orderTimeEnd"-->
<!--                      clearable-->
<!--                      type="date"-->
<!--                      value-format="yyyy-MM-dd"-->
<!--                      placeholder="结束日期"-->
<!--                  >-->
<!--                  </el-date-picker>-->
<!--                </el-form-item>-->
              </div>
              <div class="h-thirdColumn w-newColumn">
                <el-form-item label="发票号" prop="invoiceIdStr">
                  <el-input v-model="formInline.invoiceIdStr" placeholder="请输入"></el-input>
                </el-form-item>
                  <el-form-item label="物流单号" prop="orderWaybillId">
                      <el-input v-model="formInline.orderWaybillId" placeholder="请输入"></el-input>
                  </el-form-item>
              </div>
            </div>
          </el-collapse-transition>
        </el-form>
        <div class="l-screenBox">
          <div class="l-screen" @click="collapseChange">
            <img :src="isScreen?closeScreen:drawScreen" alt="">
            <div class="l-screenText">{{isScreen?"收起":"下拉"}}</div>
          </div>
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
          </div>
        </div>
      </div>
    </div>
    <!--查询end-->

    <!--列表-->
    <div class="h-table h-mrt30 tableclslist">
      <el-table
          ref="ddtable"
          :data="tableData"
          stripe
          border
          :show-overflow-tooltip="true"
          style="width: 100%"
          max-height="450"
      >
        <el-table-column
            fixed
            prop="orderType"
            label="单据类型"
            width="80">
          <template scope="scope">
              {{scope.row.orderType==1?'销售':scope.row.orderType==2?'退货':''}}
          </template>
        </el-table-column>
        <el-table-column
            prop="sapCode"
            label="订单编号"
            fixed
            :show-overflow-tooltip="true"
            width="160">
        </el-table-column>
        <el-table-column
            prop="orderTime"
            label="订单下单日期"
            fixed
            width="110">
        </el-table-column>
        <el-table-column
            prop="soldToCode"
            label="售达方编码"
            :show-overflow-tooltip="true"
            width="100">
        </el-table-column>
        <el-table-column
            prop="soldToName"
            label="售达方名称"
            :show-overflow-tooltip="true"
            width="200">
        </el-table-column>
        <el-table-column
            prop="customerChannelCode"
            label="客户渠道"
            min-width="90">
          <template scope="scope">
<!--            001高科  002医疗 003血站 004制药企业 005感控 006三检 007疾控 008农牧 009GSP 010输血科-->
            {{scope.row.customerChannelCode=='001'?'高科':
              scope.row.customerChannelCode=='002'?'医疗':
              scope.row.customerChannelCode=='003'?'血站':
              scope.row.customerChannelCode=='004'?'制药企业':
              scope.row.customerChannelCode=='005'?'感控':
              scope.row.customerChannelCode=='006'?'三检':
              scope.row.customerChannelCode=='007'?'疾控':
              scope.row.customerChannelCode=='008'?'农牧':
              scope.row.customerChannelCode=='009'?'GSP':
              scope.row.customerChannelCode=='010'?'输血科':''
            }}
          </template>
        </el-table-column>
        <el-table-column
            prop="contactName"
            label="收货联系人"
            width="100">
        </el-table-column>
        <el-table-column
            prop="firsttelephone"
            label="联系电话"
            width="100">
        </el-table-column>
        <el-table-column
            prop="toAddress"
            label="收货地址"
            :show-overflow-tooltip="true"
            width="100">
        </el-table-column>
        <el-table-column
            prop="toCityName"
            label="送达城市"
            :show-overflow-tooltip="true"
            width="80">
        </el-table-column>
        <el-table-column
            prop="toProvincesName"
            label="送达省份"
            :show-overflow-tooltip="true"
            width="80">
        </el-table-column>
        <el-table-column
            prop="materialCode"
            label="物料编号"
            :show-overflow-tooltip="true"
            width="100">
        </el-table-column>
        <el-table-column
            prop="materialName"
            label="物料名称"
            :show-overflow-tooltip="true"
            width="110">
        </el-table-column>
        <el-table-column
            prop="unit"
            label="国科单位"
            width="80">
        </el-table-column>
        <el-table-column
            prop="currencyCode"
            label="币种编码"
            width="80">
        </el-table-column>
        <el-table-column
            prop="proNumber"
            label="产品数量"
            width="80">
        </el-table-column>
        <el-table-column
            prop="unitSellingPrice"
            label="不含税价格"
            width="100">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.unitSellingPrice}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="unitPrice"
            label="含税价格"
            width="90">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.unitPrice}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="totalPrice"
            label="含税总金额"
            width="100">
          <template scope="scope">
            <div style="text-align: right;">
              {{scope.row.totalPrice}}
            </div>
          </template>
        </el-table-column>
        <el-table-column
            prop="fhdate"
            label="发货时间"
            width="90">
        </el-table-column>
        <el-table-column
            prop="acceptTime"
            label="签收日期"
            width="100">
        </el-table-column>
          <el-table-column
                  prop="businessDate"
                  label="业绩归属月份"
                  width="100">
          </el-table-column>
        <el-table-column
            prop="waybillId"
            label="国科物流单号"
            :show-overflow-tooltip="true"
            width="140">
        </el-table-column>
        <el-table-column
                prop="orderWaybillId"
                label="物流单号"
                :show-overflow-tooltip="true"
                width="200">
            <template slot-scope="scope">
                <el-input  v-model="scope.row.orderWaybillId" @change="changeOrderWaybillId(scope.row)" :v="scope.row.orderWaybillId"></el-input>
            </template>
        </el-table-column>
        <el-table-column
            prop="invoiceIdStr"
            label="发票号"
            :show-overflow-tooltip="true"
            width="100">
        </el-table-column>
        <el-table-column
            prop="invoiceStatusStr"
            label="发票状态"
            :show-overflow-tooltip="true"
            width="100">
        </el-table-column>


          <el-table-column
              prop="userUnit"
              label="用户单位"
              width="120">
          </el-table-column>
          <el-table-column
              prop="salesRegion"
              label="销售区域"
              width="100">
          </el-table-column>
          <el-table-column
                  prop="salesRegionNew"
                  label="调整后销售区域"
                  width="100">
          </el-table-column>
      <!--    <el-table-column
              prop="acceptDate"
              label="签收日期"
              width="100">
          </el-table-column>-->
          <el-table-column
              prop="isStockUp"
              label="是否备货"
              width="100">
              <template slot-scope="scope">
                  {{scope.row.isStockUp|dictname('shifou_keyong')}}
              </template>
          </el-table-column>
          <el-table-column
              prop="deliveryAddress"
              label="提货地址"
              width="100">
          </el-table-column>
          <el-table-column
              prop="deliveryPerson"
              label="提货联系人"
              width="100">
          </el-table-column>
          <el-table-column
              prop="deliveryPersonPhone"
              label="提货联系人电话"
              width="100">
          </el-table-column>
          <el-table-column
              prop="dailyContacts"
              label="业务日常联系人"
              width="100">
          </el-table-column>
          <el-table-column
              prop="dailyContactsPhone"
              label="业务日常联系人电话"
              width="100">
          </el-table-column>
          <el-table-column
              prop="deliveryNoteAddress"
              label="随货同行单地址"
              width="100">
          </el-table-column>

          <el-table-column
              fixed="right"
              label="操作"
              width="200"
          >
          <template slot-scope="scope">
              <div style="text-align: left;">
                  <div style="text-align: left;">
                      <el-button
                          size="small" class="h-tableLink h-btn"
                          @click="openInvoice(scope.row.invoiceIdStr)">查看发票
                      </el-button>
                      <el-button
                              size="small" class="h-tableLink h-btn"
                              v-if="adminFlag"
                              @click="updateSalesRegion(scope.row)">调整
                      </el-button>
                      <el-button v-if="scope.row.areaInstid"
                                 size="small" class="h-tableLink h-btn"
                                 @click="genzongLiuch(scope.row.areaInstid)">
                          跟踪
                      </el-button>
                  </div>
              </div>
          </template>
      </el-table-column>

      </el-table>

        <!-- 新增弹出层 -->
        <el-dialog :close-on-click-modal="false"  :visible.sync="invoiceDialog" class="h-dialog2" >
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>选择发票</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;">
                    <el-table :data="invoiceData" border max-height="500px">
                        <el-table-column type="index" label="序号" width="60" align="center"/>
                        <el-table-column prop="value" label="发票号码" align="center" />
                        <el-table-column fixed="right" label="操作" width="100" align="left">
                            <template slot-scope="scope">
                                <el-button size="small" @click="getInvoice(scope.row.value)">下载</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                </div>

            </div>
        </el-dialog>

        <!-- 修改区域弹出 -->
        <el-dialog :close-on-click-modal="false"  :visible.sync="salesRegionDialog" class="h-dialog2" >
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>调整区域</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLines">
                <div style="padding: 12px;">
                    <el-form :model="updateSalesRegionDate">
                        <el-form-item label="订单编码"  class="h-elformWrap-2">
                            <el-input v-model="updateSalesRegionDate.sapCode" disabled></el-input>
                        </el-form-item>
                        <el-form-item label="收入调增区域"  class="h-elformWrap-2">
                            <el-select filterable v-model="updateSalesRegionDate.salesRegion" style="width:100%" placeholder="请选择"
                            >
                                <el-option
                                        v-for="(item,index) in areaList"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="收入调减区域" class="h-elformWrap-2">
                            <brselect category="YLRegion" :v="updateSalesRegionDate.salesRegionNew" v-model="updateSalesRegionDate.salesRegionNew"></brselect>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="cancel">取 消</el-button>
                        <el-button class="h-btn h-bBtn" @click="submitChange">确 定</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>



      <div style="display:flex;justify-content: space-between;flex-direction:row-reverse;margin-top:20px">
        <pagination :page="formInline" @query="query"/>
        <div style="display:flex;align-items: center;">
          <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                     @click="exportExcel">导出
          </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="updateList">保存
            </el-button>
        </div>
      </div>
    </div>
    <!--列表end-->
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />
  </div>
</template>
<script>
import ss from '../../api/SystemService'
import reformService from "../../api/reform/reformService";
  export default {
    data(){
      return{
        invoiceDialog:false,
        invoiceData:[],
        formInline: {
          pageSize: 10,
          pageNo: 1,
          total: 0,
          orderType: '',  //单据类型
          sdfCodeNameLike: '',  //售达方编码或名称
          sapCode: '', //订单编号
          customerChannelCode: '', //客户渠道
          materialCodeNameLike: '', //物料编码/名称
          waybillId: '', //国科物流单号
          orderTimeStart: '', //订单下单日期
          orderTimeEnd: '',  //订单下单日期
          invoiceIdStr: '',//发票号
        },
          updateSalesRegionDate:{
              sapCode:null,

          },
          salesRegionDialog:false,
        clearTime: [],
          showhistory: null,
          instid: null,
        orderTypeList: [
          {
            code: 1,
            name: '销售'
          },
          {
            code: 2,
            name: '退货'
          }
        ],
        // 001高科  002医疗 003血站 004制药企业 005感控 006三检 007疾控 008农牧 009GSP 010输血科
        customerChannelList: [
          {
            code: '001',
            name: '高科'
          },
          {
            code: '002',
            name: '医疗'
          },
          {
            code: '003',
            name: '血站'
          },
          {
            code: '004',
            name: '制药企业'
          },
          {
            code: '005',
            name: '感控'
          },
          {
            code: '006',
            name: '三检'
          },
          {
            code: '007',
            name: '疾控'
          },
          {
            code: '008',
            name: '农牧'
          },
          {
            code: '009',
            name: 'GSP'
          },
          {
            code: '010',
            name: '输血科'
          },
        ],
          areaList:[],
        // 展开折叠筛选
        isScreen:false,
        adminFlag: false,
        closeScreen:require("@/assets/images/pimg/closeallic.png"),
        drawScreen:require("@/assets/images/pimg/dobleArr.png"),
        tableData: [],
        tableChangeData: []
      }
    },
    created() {
      this.query()
      this.areaList = this.$store.getters.dictlist("YLRegion");
      this.adminFlag = this.$store.getters.hasRole('swyl_admin');
    },
    methods:{
      //时间选择
      changeTime(date){
        this.formInline.orderTimeStart = date[0]
        this.formInline.orderTimeEnd = date[1]
      },
      // 展开折叠
      collapseChange(){
        this.isScreen = !this.isScreen;
      },
      //检索
      handleFilter(){
        this.formInline.pageNo = 1;
        this.query();
      },
      //重置
      resetData(){
        this.formInline = {
          pageNo: 1,
          pageSize: 10,
          total: 0
        }
        this.clearTime = []
        this.query()
      },
      query(){
        ss.GKOrderPage.GKListPage(this.formInline).then(res=>{
          this.tableData = res.records;
          this.formInline.total = res.total || 0;
        })
      },
      //导出
      exportExcel(){
        let param = {
          orderType: this.formInline.orderType,
          sdfCodeNameLike: this.formInline.sdfCodeNameLike,
          sapCode: this.formInline.sapCode,
          customerChannelCode: this.formInline.customerChannelCode,
          materialCodeNameLike: this.formInline.materialCodeNameLike,
          waybillId: this.formInline.waybillId,
          orderTimeStart: this.formInline.orderTimeStart,
          orderTimeEnd: this.formInline.orderTimeEnd,
          invoiceIdStr: this.formInline.invoiceIdStr
        }
        ss.GKOrderPage.ExportGKList(param).then(res => { // 处理返回的文件流
          const link = document.createElement('a')
          let blob = new Blob([res.data],{type: 'application/vnd.ms-excel'});
          link.style.display = 'none'
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download', `国科列表.xlsx`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }).catch(function (error) {
          console.log("导出错误",error.toString())
        });
      },
        /**获取发票*/
        getInvoice(invoiceId){

            let param = {
                invoiceNo:invoiceId
            }
            ss.GKOrderPage.getInvoice(param).then(rd=>{
                if( rd.f){
                    window.open(rd.msg, '_blank')
                }

            })
        },
        updateList(){
            ss.GKOrderPage.updateGuokeOrder({"list":this.tableChangeData}).then(rd => {
                this.$msg.msgs("调整保存成功");
                this.query();
            })
        },
        changeOrderWaybillId(row){
            this.tableChangeData.push(row);
            console.log(this.tableChangeData,"this.tableChangeData")
        },

        openInvoice(invoiceIdStr){
            this.invoiceDialog = true;
            this.invoiceData = [];

            if (!invoiceIdStr) {
                console.log('invoiceIdStr 为空');
                return;
            }
            // 安全处理：确保 invoiceIdStr 是字符串且非空
            const ids = (invoiceIdStr || '').toString().split(',').filter(item => item.trim() !== '');

            this.invoiceData = ids.map(item => ({
                value: item.trim()
            }));

            console.log('invoiceData', this.invoiceData);
        },

        updateSalesRegion(row){
            console.log(row);
            this.salesRegionDialog = true;
            this.updateSalesRegionDate = row;
            if(row.salesRegionNew != null && row.salesRegionNew != ''){
                this.updateSalesRegionDate.salesRegion = row.salesRegionNew;
                this.updateSalesRegionDate.salesRegionNew = null;
            }
        },

        submitChange(){
            console.log(this.updateSalesRegionDate);
            ss.GKOrderPage.updateSalesRegion(this.updateSalesRegionDate).then(rd=>{
                this.$msg.msgs("提交成功！")
                this.salesRegionDialog = false;
                this.query();
            })
        },
        cancel () {
            this.salesRegionDialog = false;
        },
        //跟踪
        genzongLiuch(instid) {
            this.instid = instid;

            this.showhistory = true;
        },
    }
  }
</script>
<style scoped>
.xiangmu .h-piece, .h-mrt30 {
  margin: 20px;
}

.h-formBtnOut .h-mr20 {
  margin-left: 1rem !important;
}

.D-date .el-cascader {
  line-height: 0;
}
.tableclslist	.h-tableLink{
  padding:0px 2px!important;
}
.h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__label{
  width: 20%;
}
.h-formbLine.qlplshyj .h-elformWrap-1 .el-form-item__content{
  width: 80%;
}
</style>
